import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  gptPrompts: [],
  isLoaded: false,
  isLoading: false,
}

const gptPromptsSlice = createSlice({
  name: 'gptPrompts',
  initialState,
  reducers: {
    fetchGptPromptsSuccess: (state, { payload }) => ({
      ...state,
      gptPrompts: payload,
      isLoaded: true,
      isLoading: false,
    }),
    fetchGptPromptsFailure: (state) => ({
      ...state,
      isLoading: false,
    }),
    updateGptPromptSuccess: (state, { payload }) => {
      state.gptPrompts = state.gptPrompts.map((prompt) =>
        prompt.id === payload.id ? payload : prompt
      )
    },
    clearData: () => initialState,
  },
})

export default gptPromptsSlice
